import React from 'react';

const Pagination = ({ pagination, onPageChange, onLimitChange, loading, itemName }) => {
  if (!pagination) return null;

  const getPageRange = () => {
    const { page, pages } = pagination;
    const total = pages;
    const current = page;
    
    if (total <= 1) return [1];
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const range = [];
    const delta = 1; // Number of pages around current

    range.push(1);

    if (current > delta + 2) {
      range.push('...');
    }

    const start = Math.max(2, current - delta);
    const end = Math.min(total - 1, current + delta);

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    if (current < total - delta - 1) {
      range.push('...');
    }

    range.push(total);
    return range;
  };

  return (
    <div className="pagination">
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginRight: 'auto' }}>
        <span style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>
          Showing {Math.min(pagination.limit * (pagination.page - 1) + 1, pagination.total)} - {Math.min(pagination.limit * pagination.page, pagination.total)} of {pagination.total} {itemName}
        </span>
        
        {onLimitChange && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span style={{ fontSize: '0.8125rem', color: 'var(--text-muted)' }}>Per page:</span>
            <select 
              value={pagination.limit} 
              onChange={(e) => onLimitChange(Number(e.target.value))}
              style={{ 
                padding: '0.2rem 0.4rem', 
                borderRadius: '4px', 
                border: '1px solid var(--border-light)', 
                background: 'var(--bg-card)',
                color: 'var(--text-primary)',
                fontSize: '0.8125rem',
                cursor: 'pointer'
              }}
            >
              {[10, 20, 50, 100].map(l => <option key={l} value={l}>{l}</option>)}
            </select>
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: '0.25rem' }}>
        <button 
          className="page-btn" 
          onClick={() => onPageChange(pagination.page - 1)}
          disabled={pagination.page === 1 || loading}
        >
          Previous
        </button>
        {getPageRange().map((p, i) => (
          p === '...' ? (
            <span key={`ellipsis-${i}`} style={{ color: 'var(--text-muted)', padding: '0 0.5rem', alignSelf: 'center' }}>...</span>
          ) : (
            <button 
              key={p}
              className={`page-btn ${pagination.page === p ? 'active' : ''}`}
              onClick={() => onPageChange(p)}
              disabled={loading}
            >
              {p}
            </button>
          )
        ))}
        <button 
          className="page-btn" 
          onClick={() => onPageChange(pagination.page + 1)}
          disabled={pagination.page === (pagination.pages || 1) || loading}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
